'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _leaflet = require('leaflet');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _propTypes2.default.instanceOf(_leaflet.Map);


//////////////////
// WEBPACK FOOTER
// ./~/react-leaflet/lib/propTypes/map.js
// module id = 33
// module chunks = 0